<template>
  <div class="login-container" :style="{ background: 'url(' + bgLogin + ')' }">
    <el-form ref="loginForm" :model="model" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <h3 class="title">上城区中队执法规范化管理平台</h3>
      </div>

      <el-form-item prop="Account" class="c-form-content">
        <img class="img-user" src="@/assets/images/user.png" />
        <div class="c-name">用户名</div>
        <el-input ref="userName" v-model="model.Account" placeholder="用户名" name="userName" type="text" tabindex="1" auto-complete="on" />
      </el-form-item>

      <el-form-item prop="Password" class="c-form-content">
        <img class="img-user" src="@/assets/images/password.png" />
        <div class="c-name">密&#12288;码</div>
        <el-input :key="passwordType" ref="password" v-model="model.Password" :type="passwordType" placeholder="密码" name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <!-- <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /> -->
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary" class="btn-login" @click.native.prevent="handleLogin">登 录</el-button>
    </el-form>
  </div>
</template>
<script>
import md5 from 'js-md5';
import Cookies from 'js-cookie'
export default {
  name: 'Login',
  data() {
    return {
      model: {
        Account: null,
        Password: null
      },
      loginRules: {
        Account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      passwordType: 'password',
      bgLogin: require('@/assets/bg_login.png')
    };
  },
  methods: {
    showPwd() {
      let that = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(() => {
        that.$refs.password.focus();
      });
    },
    handleLogin() {
      let that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let model = {
            Account: that.model.Account,
            Password: md5(that.model.Password)
          }
          that.$store.dispatch('login', model)
            .then(res => {
              that.loading = false;
              if (res.MsgCode === 0) {
                let data = res.Data;
                Cookies.set('Token', data.Token);
                Cookies.set('UserId', data.Id);
                Cookies.set('DisplayName', data.DisplayName);
                Cookies.set('DeptId', data.DeptId);
                Cookies.set('UserRoleIds', data.UserRoleIds);

                // let roleIdList = Cookies.get('UserRoleIds').split(',');
                // if (_.intersection(roleIdList, ['1']).length > 0) {
                //   that.$router.push({ name: 'caseaddlist' });
                // } else if (_.intersection(roleIdList, ['2']).length > 0) {
                //   that.$router.push({ name: 'caseaddlist' });
                // } else if (_.intersection(roleIdList, ['3']).length > 0) {
                //   that.$router.push({ name: 'caseshlist' });
                // } else {
                //   that.$router.push({ name: 'home' });
                // }

                that.$router.push({ path: '/' });
                that.loading = false;
              } else {
                that.$alert(res.Message, '提示', {
                  confirmButtonText: '确定'
                });
              }
            })
            .catch((e) => {
              that.loading = false;
            });
        } else {
          that.$message({
            message: '用户名或密码错误',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: black;
$cursor: black;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 66px;
    width: 464px;
    line-height: 66px;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    letter-spacing: 0;
    border: 2px solid #bcbcbc;
    border-radius: 6px;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: black;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    background: transparent;
    display: flex;
    .el-form-item__content {
      display: flex;
      .el-form-item__error {
        right: 0;
        position: absolute;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-form {
    position: relative;
    width: 806px;
    height: 540px;
    // margin: 240px 560px 0 560px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 2px 36px -4px rgba(16, 17, 117, 0.41);
    border-radius: 16px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .title-container {
    position: relative;

    .title {
      font-weight: bold;
      font-family: PingFang-SC-Heavy;
      font-size: 36px;
      color: #4375ff;
      letter-spacing: 0;
      text-align: center;
      margin: 72px 0px 60px 0px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}

.c-name {
  width: 72px;
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #4375ff;
  letter-spacing: 0;
  line-height: 66px;
  margin: 0 24px;
}

.img-user {
  width: 27px;
  height: 30px;
  margin: 18px 0 18px 97px;
}
.btn-login {
  width: 612px;
  height: 70px;
  margin: 60px 97px;
  background: #4279ff;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue